<template>
  <!-- Register Section Begin -->
  <DefaultLayout>
    <!-- Breadcrumb Section Begin -->
    <div class="breacrumb-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="breadcrumb-text">
              <router-link to="/"><i class="mdi mdi-home"></i> {{ $t("main.home") }}</router-link>
              <span>{{ $t("auth.register") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Breadcrumb Form Section Begin -->
    <div class="register-login-section spad">
      <div class="container">
        <div class="row">
          <div class="text-center col-lg-8 offset-lg-2 alert alert-success" v-if="success">
            <p v-if="success">
              {{ message }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 offset-lg-1 alert alert-danger text-center" v-if="has_error && !success">
            <p v-if="error == 'Validation Error'">
              {{ error }}
            </p>
            <p v-else-if="error == 'Condition Error'">
              {{ conditionsError }}
            </p>
            <p v-else>
              {{ $t("auth.error.message", { action: $t("auth.register") }) }}
            </p>
          </div>
          <div class="col-lg-6 offset-lg-3">
            <div class="loader" v-if="loader"></div>
            <div class="register-form" v-bind:class="{ 'has-error': has_error && errors }">
              <h2>{{ $t("auth.register") }}</h2>
              <form method="post" @submit.prevent="register" v-if="!success">
                <div class="group-input" v-bind:class="{
                  'is-invalid': has_error && errors.username,
                }">
                  <label for="username" v-bind:class="{
                    'text-danger': has_error && errors.username,
                  }">{{ $t("attr.username") }} *</label>
                  <input type="text" id="username" v-model="username" v-bind:class="{
                    'is-invalid': has_error && errors.username,
                  }" />
                  <span class="help-block text-danger" v-if="has_error && errors.username">{{ $t(errors.username[0], {
                    attribute: "username"
                  }) }}</span>
                </div>
                <div class="group-input" v-bind:class="{
                  'is-invalid': has_error && errors.lastname,
                }">
                  <label for="lastname" v-bind:class="{
                    'text-danger': has_error && errors.lastname,
                  }">{{ $t("attr.lastname") }} *</label>
                  <input type="text" id="lastname" v-model="lastname" v-bind:class="{
                    'is-invalid': has_error && errors.lastname,
                  }" />
                  <span class="help-block text-danger" v-if="has_error && errors.lastname">{{ $t(errors.lastname[0], {
                    attribute: "Lastname"
                  }) }}</span>
                </div>
                <div class="group-input" v-bind:class="{
                  'is-invalid': has_error && errors.firstname,
                }">
                  <label for="firstname" v-bind:class="{
                    'text-danger': has_error && errors.firstname,
                  }">{{ $t("attr.firstname") }} *</label>
                  <input type="text" id="firstname" v-model="firstname" v-bind:class="{
                    'is-invalid': has_error && errors.firstname,
                  }" />
                  <span class="help-block text-danger" v-if="has_error && errors.firstname">{{
                    $t(errors.firstname[0], { attribute: "Firstname" })
                  }}</span>
                </div>
                <div class="group-input" v-bind:class="{
                  'is-invalid': has_error && errors.email,
                }">
                  <label for="username" v-bind:class="{
                    'text-danger': has_error && errors.email,
                  }">{{ $t("attr.email") }} *</label>
                  <input type="mail" id="username" v-model="email" v-bind:class="{
                    'is-invalid': has_error && errors.email,
                  }" />
                  <span class="help-block text-danger" v-if="has_error && errors.email">{{ $t(errors.email[0], {
                    attribute: "email"
                  }) }}</span>
                </div>

                <div class="group-input" v-bind:class="{ 'has-error': has_error && errors.password }">
                  <label for="password" v-bind:class="{
                    'text-danger': has_error && errors.password,
                  }">{{ $t("attr.password") }} *</label>
                  <input v-bind:class="{
                    'is-invalid': has_error && errors.password,
                  }" type="password" id="password" v-model="password" />
                  <span class="help-block text-danger" v-if="has_error && errors.password">{{
                    $t(errors.password[0], { attribute: "mot de passe" })
                  }}</span>
                </div>
                <label for="save-pass">
                  <input v-bind:class="{
                    'is-invalid': has_error && errors.conditions,
                  }" type="checkbox" id="save-pass" v-model="conditions" />
                  <span class="checkmark ml-1"></span>

                  <a style="text-decoration: underline; color: var(--color-5);" @click="show('term-of-use-modal')">{{
                    $t("sentence.readAndAcceptTermOfUse") }}</a>
                  <span class="help-block text-danger" v-if="has_error && errors.conditions">{{ errors.conditions
                  }}</span>
                </label>
                <button type="submit" class="btn-site btn-auth">
                  {{ $t("auth.register") }}
                </button>
              </form>
              <div class="switch-login">
                <router-link :to="{ name: 'login' }" class="or-login">
                  {{ $t("general.or") }} {{ $t("auth.login") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <term-of-use-modal></term-of-use-modal>
      </div>
    </div>
  </DefaultLayout>
  <!-- Register Form Section End -->
</template>
<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import TermOfUseModal from "@/components/modals/TermOfUseModal.vue";
export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      username: "",
      lastname: "",
      firstname: "",
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
      conditions: false,
      conditionsError: "",
    };
  },
  components: {
    TermOfUseModal,
    DefaultLayout,
  },
  methods: {
    register () {
      var app=this;
      let email=this.email;
      let password=this.password;
      let lastname=this.lastname;
      let firstname=this.firstname;
      let username=this.username;
      let roles=["ROLE_USER"];
      app.loader=true;
      window.scrollTo(0, 0);
      if (false===this.conditions) {
        this.error="Condition Error";
        this.conditionsError=this.$t("sentence.pleaseAcceptTermOfUSe");
        this.has_error=true;
        app.loader=false;
        return;
      }
      this.$store
        .dispatch("register", {
          username,
          email,
          password,
          lastname,
          firstname,
          roles,
        })
        .then(function () {
          app.success=true;
          app.message=app.$t("sentence.weHaveSentAConfirmationEmail");
          app.loader=false;
        })
        .catch(function (err) {
          app.loader=false;
          app.has_error=true;
          // alert(err)
          // Try to extract a readable message
          const res=err.response?.data||{};
          const data=res.data||{};
          const message=res.message||res.error||res.msg;

          // If "data" is an object with validation errors, build a readable string
          if (typeof data==='object'&&Object.keys(data).length>0) {
            app.errors=data;
            app.error=Object.values(data).flat().join('\n');
          } else {
            app.errors={};
            app.error=message||app.$t("auth.error.message", { action: app.$t("auth.login") });
          }
        });
    },
    show(modalName) {
      this.$modal.show(modalName);
    },
  },
};
</script>
